import React from 'react'
import PropTypes from 'prop-types'
import Pagination from './Pagination'
import EmptyResults from './EmptyResults'
import SearchResult from './SearchResult'
import { SupplierResultShape } from './prop_shapes/SupplierResultShape'

function SearchResults ({
  searchResults,
  executeSearch,
  popularSearches,
  locked,
  linkToPublicProfile,
  onLockedClick,
  category,
  sponsoredSearchResult,
  mobileAd,
  searchId
}) {
  const results = searchResults.results
  const hasResults = results.length > 0 || sponsoredSearchResult

  const handleResultClick = (event, url) => {
    if (!linkToPublicProfile) {
      onLockedClick(event, url)
    }
  }

  const renderResult = (supplier, opts = {}) => (
    <SearchResult
      key={supplier.id}
      supplier={supplier}
      sponsoredInCategoryId={opts.sponsored && category ? category.id : undefined}
      onClick={handleResultClick}
      category={category}
      linkToPublicProfile={linkToPublicProfile}
      onLockedClick={onLockedClick}
      executeSearch={executeSearch}
      locked={locked}
      popularSearches={popularSearches}
      searchId={searchId}
    />
  )

  const renderResults = () => {
    const rendered = []
    const middleIndex = Math.ceil(results.length / 2)

    results.forEach((supplier, index) => {
      if (mobileAd && index === middleIndex) {
        rendered.push(
          <div key='mobile-ad' className='show-for-small-only'>
            {mobileAd}
          </div>
        )
      }

      rendered.push(renderResult(supplier))
    })

    return rendered
  }

  const renderPagination = () => {
    if (locked) {
      return (
        <div className='text-center margin-bottom-2'>
          <button
            className='see-all-category-btn pointer-clickable'
            onClick={(e) => onLockedClick(e, window.location.href)}
          >
            See All {searchResults.total_count.toLocaleString('en-US')} {category?.name} Suppliers
          </button>
        </div>
      )
    }

    return (
      <Pagination
        currentPage={searchResults.current_page}
        totalPages={searchResults.total_pages}
        executeSearch={executeSearch}
      />
    )
  }

  const renderResultsTable = () => {
    return (
      <div className='large-12 cell' id='search-results'>
        {sponsoredSearchResult && renderResult(sponsoredSearchResult, { sponsored: true })}
        {renderResults()}
      </div>
    )
  }

  return (
    <>
      {hasResults ? renderResultsTable() : <EmptyResults popularSearches={popularSearches} />}

      <div className='cell large-12'>
        {renderPagination()}
      </div>
    </>
  )
}

SearchResults.propTypes = {
  searchResults: PropTypes.shape({
    results: PropTypes.array.isRequired,
    total_count: PropTypes.number.isRequired,
    total_pages: PropTypes.number.isRequired,
    current_page: PropTypes.number.isRequired
  }).isRequired,
  executeSearch: PropTypes.func.isRequired,
  popularSearches: PropTypes.array.isRequired,
  locked: PropTypes.bool.isRequired,
  linkToPublicProfile: PropTypes.bool.isRequired,
  onLockedClick: PropTypes.func.isRequired,
  category: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired
  }),
  sponsoredSearchResult: SupplierResultShape,
  mobileAd: PropTypes.node
}

export default SearchResults
